import type { FamousVoucher, FamousVoucherFileRef } from '@erp/rpc';

/**
 * Helpers over the Famous vouchers of an AP invoice
 * (`useAPInvoiceFamousVouchers`), so other panels can say which voucher a
 * load, order or PO line is on without building a second line list. The
 * Related lines tab uses `vouchersCoveringFile` to mark a file's rows
 * "vouchered in <voucher #>".
 */

export function famousFileKey(file: FamousVoucherFileRef): string {
  return `${file.fileType}:${file.fileNumber.trim().toUpperCase()}`;
}

/**
 * The vouchers that have at least one line on the file, newest first. $0
 * (unvouchered) vouchers cover nothing and are never returned.
 */
export function vouchersCoveringFile(
  vouchers: readonly FamousVoucher[],
  file: FamousVoucherFileRef,
): FamousVoucher[] {
  const key = famousFileKey(file);
  return vouchers
    .filter((voucher) =>
      voucher.coverage?.covered.some(
        (covered) => famousFileKey(covered) === key,
      ),
    )
    .sort((a, b) => b.voucherNumber - a.voucherNumber);
}

/** The voucher that counts for the invoice (newest with an amount), if any. */
export function currentFamousVoucher(
  vouchers: readonly FamousVoucher[],
): FamousVoucher | null {
  return vouchers.find((voucher) => voucher.isCurrent) ?? null;
}
